<script>

export default {
  name: 'TableLine',
  render: function (createElement) {
    const list = []

    this.$slots.default.forEach((el, i) => {
      if (el.tag) {
        list.push(createElement('td', {}, [el]))
      }
    })
    return createElement('tr', {}, list)
  }
}

</script>

<style lang="scss" scoped>

@import '../../styles/main-colors.scss';

tr {
  border-top: solid 1px mix($background-grey, $background-dark, 95%);
  height: 45px;
}

td {
  padding: 0px 15px 0px 15px;
  background-color: $background-light;
}

</style>



// WEBPACK FOOTER //
// src/components/common/TableLine.vue